var Component = require("!./../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./popup-game.vue"),
  /* template */
  require("!!./../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-f5351eb2!./../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./popup-game.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/components/partials/popup-game.vue
// module id = 26
// module chunks = 0